import React, { Component } from "react";
import { Button } from "semantic-ui-react";
import PropTypes from "prop-types";

export default class DeleteButton extends Component {
  render() {
    const { text, children, ...otherProps } = this.props;

    if (text || children) {
      return (
        <Button
          color="red"
          icon="trash alternate"
          labelPosition="left"
          size="small"
          content={text || children}
          {...otherProps}
        />
      );
    }

    return (
      <Button
        color="red"
        icon="trash alternate"
        size="small"
        title="Delete record"
        {...otherProps}
      />
    );
  }
}

DeleteButton.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
};

DeleteButton.defaultProps = {
  text: null,
  children: null,
};
